import { css } from '@emotion/css'

export const DefaultClass = css`
  .ant-upload-list {
    margin-top: 10px;
    max-height: 150px;
    overflow: auto;
  }
`
